import { OrderKeys } from '../OrderKeys';
import { OptionsDictionary } from './SortOptionDefinitions';
import { createNonDisplayOptionDefinition } from './SortOptionsHelper';

export const serverUserSortOptions: OptionsDictionary = {
  'userName': createNonDisplayOptionDefinition('userName', OrderKeys.username),
  'displayName': createNonDisplayOptionDefinition('displayName', OrderKeys.displayName),
  'maxSiteRole': createNonDisplayOptionDefinition('maxSiteRole', OrderKeys.maxSiteRole),
  'siteCount': createNonDisplayOptionDefinition('siteCount', OrderKeys.siteCount),
  'lastSignIn': createNonDisplayOptionDefinition('lastSignIn', OrderKeys.lastSignIn),
  'domainName': createNonDisplayOptionDefinition('domainName', OrderKeys.domainName),
  'licenseLevel': createNonDisplayOptionDefinition('licenseLevel', OrderKeys.licenseLevel),
};
